export default __webpack_public_path__ + "static/media/renBTC_gradient.e77d28b7.svg";